import type { RawParams } from "@uirouter/react";
import { FIND_LEADS_SAVED_SEARCH_ROUTE } from "app/pages/sales-intelligence/constants/routes";
import { ACCOUNTS_WITH_SIGNALS_COLUMN } from "../configuration/table-columns/columnNames";
import { NEW_ACCOUNTS_COLUMN } from "../configuration/table-columns/saved-searches/columnNames";
import type { SavedSearchesItemDto } from "../types/savedSearchesDto";
import type { CellProps } from "../types/table";
import { getSignalId } from "../utils/getSignalId";

export function getSavedSearchesRedirect({ field, row }: CellProps<SavedSearchesItemDto>): [string, RawParams] {
    const routeBaseParams = {
        savedSearchId: row.searchId,
    };

    switch (field) {
        case NEW_ACCOUNTS_COLUMN:
            return [
                FIND_LEADS_SAVED_SEARCH_ROUTE,
                {
                    ...routeBaseParams,
                    isNewOnly: true,
                },
            ];
        case ACCOUNTS_WITH_SIGNALS_COLUMN:
            const signalId = getSignalId(field);
            const signalsStateParams: RawParams = signalId ? { signalId } : {};

            return [
                FIND_LEADS_SAVED_SEARCH_ROUTE,
                {
                    ...routeBaseParams,
                    ...signalsStateParams,
                },
            ];
        default:
            return [FIND_LEADS_SAVED_SEARCH_ROUTE, routeBaseParams];
    }
}
